import { render } from "./CategoryTree.vue?vue&type=template&id=066d8899&scoped=true&ts=true"
import script from "./CategoryTree.vue?vue&type=script&lang=ts"
export * from "./CategoryTree.vue?vue&type=script&lang=ts"

import "./CategoryTree.vue?vue&type=style&index=0&id=066d8899&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066d8899"]])

export default __exports__